import { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from '@/components/ui/credenza.tsx';

export const CreateEventRuleDialog = ({
  isDialogOpen,
  setIsDialogOpen,
  children,
}: {
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
  children: ReactNode;
}) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-end">
        <Credenza
          open={isDialogOpen}
          onOpenChange={(value) => {
            setIsDialogOpen(value);
          }}
        >
          <CredenzaTrigger asChild>
            <Button
              type="button"
              size="sm"
              className="flex items-center gap-2 text-sm text-white"
            >
              Create Rule
            </Button>
          </CredenzaTrigger>
          <CredenzaContent className="max-w-2xl gap-1">
            <CredenzaHeader className="pb-0">
              <CredenzaTitle>Create Event Rule</CredenzaTitle>
              <CredenzaDescription>
                Create event based on what push event will be received
              </CredenzaDescription>
            </CredenzaHeader>

            <CredenzaBody className="max-w-2xl gap-1">{children}</CredenzaBody>
            <CredenzaFooter className="pb-0">
              <div></div>
            </CredenzaFooter>
          </CredenzaContent>
        </Credenza>
      </div>
    </div>
  );
};
